import { AlertCircle, X } from 'lucide-react';
import { useToastStore } from '../../context/toastStore';

/** The toasts from context/toastStore.js, bottom right, announced to screen readers. */
export default function Toaster() {
  const { toasts, dismiss } = useToastStore();
  if (toasts.length === 0) return null;
  return (
    <div className="pointer-events-none fixed inset-x-4 bottom-4 z-[9998] flex flex-col items-end gap-2 sm:inset-x-auto sm:right-4">
      {toasts.map((t) => (
        <div
          key={t.id}
          role="alert"
          className="pointer-events-auto flex w-full max-w-sm items-start gap-2 rounded-lg border border-red-200 bg-white p-3 text-sm text-red-800 shadow-lg dark:border-red-800 dark:bg-neutral-800 dark:text-red-200"
        >
          <AlertCircle className="mt-0.5 h-4 w-4 flex-shrink-0" />
          <span className="flex-1">{t.message}</span>
          <button type="button" onClick={() => dismiss(t.id)} aria-label="Dismiss" className="text-neutral-400 hover:text-neutral-700 dark:hover:text-neutral-200">
            <X className="h-4 w-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
